import Constants from '../common/constants';

const imageFolder = `${Constants.IMAGE_FOLDER}about/`;

export default [
    {
        type: "Paragraph",
        title: "About",
        text: "The Holy Road is an interactive web documentary about one of the holiest and most controversial roads in the world: Route 60, the road that stretches through the occupied West Bank. Join journalist Derk Walters, photographer Dirk-Jan Visser and producer Edmée van Rijn on their journey from south to north; past watchtowers and checkpoints, settlements and refugee camps, and dive into the stories of various individuals who live in this controversial area. What does the occupation look like? What can you actually feel of the continuous conflict and the related restrictions? But most of all: how do people live here?"
    },
    {
        type: "Paragraph",
        text: "The Holy Road is a production by Prospektor. "
    },
    {
        type: "Image",
        image: {
            mobile: `${imageFolder}DerkWalters-EdmeeVanRijn-DirkJanVisser__mobile.jpg`,
            tablet: `${imageFolder}DerkWalters-EdmeeVanRijn-DirkJanVisser.jpg`,
            desktop: `${imageFolder}DerkWalters-EdmeeVanRijn-DirkJanVisser.jpg`,
            text: "Derk Walters, Edmée van Rijn and Dirk-Jan Visser"
        }
    },
    {
        type: "Quote",
        quote: "Derk Walters: 'For a long time, it has been a frustration to me that the occupation was so difficult to describe in individual news articles, partly because of the impenetrable and bureaucratic situation that Israel has created. With this interactive documentary, we would like to offer people the experience to feel and see what the occupation implies to Palestinians as well as to Jewish settlers.'"
    },
    {
        type: "Paragraph",
        title: "Research",
        text: "Derk Walters, Dirk-Jan Visser."
    },
    {
        type: "Paragraph",
        title: "Camera & photography",
        text: "Dirk-Jan Visser, Edmée van Rijn "
    },
    {
        type: "Paragraph",
        title: "Texts",
        text: "Derk Walters"
    },
    {
        type: "Paragraph",
        title: "translation",
        text: "Dvora Friedman, Hussam Taha, Riam Némmire, Edmée van Rijn, Magd Sora, Alice Coster, Anne Mai Baan, Rosanna Stek, Diana Ader, Cecily Layzell."
    },
    {
        type: "Paragraph",
        title: "Online concept",
        text: "Dirk-Jan Visser, Eefje Blankevoort, Martijn van Tol, Hamid Sallali"
    },
    {
        type: "Paragraph",
        title: "Online director and final editing",
        text: "Eefje Blankevoort (Prospektor)"
    },
    {
        type: "Paragraph",
        title: "video editing",
        text: "Eefje Blankevoort (Prospektor)"
    },
    {
        type: "Paragraph",
        title: "Design",
        text: "Hamid Sallali"
    },
    {
        type: "Paragraph",
        title: "Development",
        text: "Vincent Kranendonk (Studio Rabota), Joost Baaij (Scrollytelling)"
    },
    {
        type: "Paragraph",
        title: "Music",
        text: "Oliver Lyu"
    },
    {
        type: "Paragraph",
        title: "Audio correction",
        text: "Björn Warning"
    },
    {
        type: "Paragraph",
        title: "Production",
        text: "Edmée van Rijn in Israel and Palestine, Laura Verduijn voor Prospektor"
    },
    {
        type: "Paragraph",
        text: "©Prospektor"
    },
    {
        type: "Paragraph",
        title: "Background",
        text: "June 2017 was the 50th anniversary of the occupation of the West Bank by Israel. The end is nowhere in sight: the illegal Jewish settlements have continued to expand, with ever increasing pace. Even though the Israeli government does not consider these settlements as obstacles for peace, the Palestinians suffer under the increasing restrictions. In The Holy Road, we intend to explore what daily life on the West Bank looks like after fifty years of occupation – the daily life of Palestinians as well as of Jewish settlers."
    },
    {
        type: "Paragraph",
        title: "Support",
        text: "The Holy Road is made possible by the generous support of different private donors and the IIC (Stichting Internationale Informatie en Communicatie)"
    },
    {
        type: "Image",
        image: {
            mobile: `${imageFolder}logos__mobile.jpg`,
            tablet: `${imageFolder}logos.jpg`,
            desktop: `${imageFolder}logos.jpg`
        }
    },
]



// WEBPACK FOOTER //
// ./src/data/about.js